<template>
  <v-expansion-panels v-model="detail_panel" multiple>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <v-icon>mdi-ship-wheel</v-icon><span class="headerTitle">{{ labels.hullRiskDetTitle }}</span>
        </div>
        </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="vslDetList"
                    v-model="mainForm.vesNo"
                    :label="labels.vesNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="vesNo"
                    :data-vv-as="labels.vesNo"
                    :error-messages="errors.collect('vesNo')"
                    v-validate="'required'"
                    :loading="loading"
                    @input="doVesNo"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg4 xs12>
                  <cal-picker v-model="mainForm.issDate" :label="labels.issDate"></cal-picker>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-autocomplete
                    :items="coverList"
                    v-model="mainForm.intCvrd"
                    :label="labels.intCvrd"
                    item-text="label"
                    item-value="value"
                    data-vv-name="intCvrd"
                    :data-vv-as="labels.intCvrd"
                    :error-messages="errors.collect('intCvrd')"
                    :loading="loading"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesName" :label="labels.vesName" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    v-model="mainForm.imoRefNo"
                    :label="labels.imoRefNo"
                    :error-messages="errors.collect('imoRefNo')"
                    data-vv-name="imoRefNo"
                    :data-vv-as="labels.imoRefNo"
                    v-validate="'max:40'"
                  ></v-text-field>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-textarea v-model="mainForm.vesDesc" :label="labels.vesDesc" rows="5" disabled></v-textarea>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="mainForm.chartRefNo"
                        :label="labels.chartRefNo"
                        :error-messages="errors.collect('chartRefNo')"
                        data-vv-name="chartRefNo"
                        :data-vv-as="labels.chartRefNo"
                        v-validate="'max:40'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="mainForm.mortgagee"
                        :label="labels.mortgagee"
                        :error-messages="errors.collect('mortgagee')"
                        data-vv-name="mortgagee"
                        :data-vv-as="labels.mortgagee"
                        v-validate="'max:40'"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field v-model="mainForm.yrBuilt" :label="labels.yrBuilt" disabled></v-text-field>
                </v-flex>
                <v-flex lg8 xs12></v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesFlag" :label="labels.vesFlag" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field v-model="mainForm.grt" :label="labels.grt" disabled></v-text-field>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesCls" :label="labels.vesCls" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field v-model="mainForm.nrt" :label="labels.nrt" disabled></v-text-field>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesType" :label="labels.vesType" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field v-model="mainForm.dwt" :label="labels.dwt" disabled></v-text-field>
                </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesOwn" :label="labels.vesOwn" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12> </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesAgtDesc" :label="labels.vesAgt" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12> </v-flex>
                <v-flex lg8 xs12>
                  <v-text-field v-model="mainForm.vesConstn" :label="labels.vesConstn" disabled></v-text-field>
                </v-flex>
                <v-flex lg4 xs12> </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'
import { isEqual } from '@/utils/compare'
export default {
  data() {
    return {
      labels: {
        hullRiskDetTitle: 'Marine Hull Risk Details',
        vesNo: 'Vessel No.',
        issDate: 'Issue Date',
        intCvrd: 'Interest Covered',
        vesName: 'Vessel Name',
        vesDesc: 'Vessel Description',
        imoRefNo: 'IMO Ref No.',
        chartRefNo: 'Chartered Ref No.',
        mortgagee: 'Mortgagee',
        yrBuilt: 'Year Build',
        vesFlag: 'Vessel Flag',
        vesCls: 'Vessel Class',
        vesType: 'Vessel Type',
        grt: 'Gross Registered Tonnes (GRT)',
        nrt: 'Net Registered Tonnes (NRT)',
        dwt: 'Dead Weight Tonnes (DWT)',
        vesOwn: 'Vessel Owner / Manager',
        vesAgt: 'Vessel Agent / Broker',
        vesConstn: 'Vessel Construction'
      },
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        vesNo: undefined,
        issDate: undefined,
        intCvrd: undefined,
        vesName: undefined,
        vesDesc: undefined,
        imoRefNo: undefined,
        chartRefNo: undefined,
        mortgagee: undefined,
        yrBuilt: undefined,
        vesFlag: undefined,
        vesCls: undefined,
        vesType: undefined,
        grt: undefined,
        nrt: undefined,
        dwt: undefined,
        vesOwn: undefined,
        vesAgt: undefined,
        vesAgtDesc: undefined,
        vesConstn: undefined
      },
      loading: false,
      vslDetList: [],
      coverList: [],
      detail_panel: []
    }
  },
  props: {
    polRisk: Object
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    getVslDet() {
      return this.vslDetList.filter((vslDet) => {
        return vslDet.value === this.mainForm.vesNo
      })
    }
  },
  methods: {
    doInit() {
      this.getPolHullRisk().then(() => {
        this.getHullParams().then(() => {
          this.doVesNo()
          this.copymainForm = clone(this.mainForm)
        })
      })
    },
    async getPolHullRisk() {
      const apiUrl = this.$store.state.underwriting.policyHullRiskSettings.menu.getPolHullRisk
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polRisk.riskGrpNo,
            riskNo: this.polRisk.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polHullRisk) {
            this.mainForm.polNo = result.data.polHullRisk.data.polNo
            this.mainForm.renCnt = result.data.polHullRisk.data.renCnt
            this.mainForm.endtCnt = result.data.polHullRisk.data.endtCnt
            this.mainForm.riskGrpNo = result.data.polHullRisk.data.riskGrpNo
            this.mainForm.riskNo = result.data.polHullRisk.data.riskNo
            this.mainForm.vesNo = result.data.polHullRisk.data.vesNo
            this.mainForm.issDate = result.data.polHullRisk.data.issDate
            this.mainForm.intCvrd = result.data.polHullRisk.data.intCvrd
            this.mainForm.vesName = result.data.polHullRisk.data.vesName
            this.mainForm.imoRefNo = result.data.polHullRisk.data.imoRefNo
            this.mainForm.chartRefNo = result.data.polHullRisk.data.chartRefNo
            this.mainForm.mortgagee = result.data.polHullRisk.data.mortgagee
          }
          this.hideInitLoading()
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    hideInitLoading() {
      // Set parent policy.initLoading to false
      this.$emit('hide-init-loading')
    },
    async getHullParams() {
      const apiUrl = this.$store.state.underwriting.policyHullRiskSettings.menu.getHullParams
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            busCls: this.polRisk.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            this.$set(this, 'vslDetList', result.data.vslDetList)
            this.$set(this, 'coverList', result.data.coverList)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doVesNo() {
      if (this.getVslDet.length > 0) {
        this.mainForm.vesName = this.getVslDet[0].secondaryValue.data.vesName
        this.mainForm.vesDesc = this.getVslDet[0].secondaryValue.data.vesDesc
        this.mainForm.yrBuilt = this.getVslDet[0].secondaryValue.data.yrBuilt
        this.mainForm.vesFlag = this.getVslDet[0].secondaryValue.data.vesFlag + ' - ' + this.getVslDet[0].secondaryValue.data.vesFlagDesc
        this.mainForm.vesCls = this.getVslDet[0].secondaryValue.data.vesCls + ' - ' + this.getVslDet[0].secondaryValue.data.vesClsDesc
        this.mainForm.vesType = this.getVslDet[0].secondaryValue.data.vesType + ' - ' + this.getVslDet[0].secondaryValue.data.vesTypeDesc
        this.mainForm.grt = this.getVslDet[0].secondaryValue.data.grt
        this.mainForm.nrt = this.getVslDet[0].secondaryValue.data.nrt
        this.mainForm.dwt = this.getVslDet[0].secondaryValue.data.dwt
        this.mainForm.vesOwn = this.getVslDet[0].secondaryValue.data.vesOwn
        this.mainForm.vesAgt = this.getVslDet[0].secondaryValue.data.vesAgt
        this.mainForm.vesAgtDesc = this.getVslDet[0].secondaryValue.data.vesAgtDesc
        this.mainForm.vesConstn = this.getVslDet[0].secondaryValue.data.vesConstn + ' - ' + this.getVslDet[0].secondaryValue.data.vesConstnDesc
      } else {
        this.mainForm.vesName = ''
        this.mainForm.vesDesc = ''
        this.mainForm.yrBuilt = 0
        this.mainForm.vesFlag = ''
        this.mainForm.vesCls = ''
        this.mainForm.vesType = ''
        this.mainForm.grt = 0
        this.mainForm.nrt = 0
        this.mainForm.dwt = 0
        this.mainForm.vesOwn = ''
        this.mainForm.vesAgt = ''
        this.mainForm.vesAgtDesc = ''
        this.mainForm.vesConstn = ''
      }
    },
    async doPolHullRiskSave() {
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          const result = await this.$store.dispatch('savePolHullRisk', this.mainForm)
          if (result) {
            this.copymainForm = clone(this.mainForm)
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyHullRiskSettings.init !== 1) {
      this.$store.dispatch('policyHullRiskInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
